<template>
  <div class="content">
    <h5-header :header-msg="headerMsg"></h5-header>
    <div class="order_msg">
      <div>
        <p>
          <span>您的收入</span>
          <span>￥{{ordersObj.income}}</span>
        </p>
        <p>
          <span>订单金额</span>
          <span>￥{{ordersObj.money}}</span>
        </p>
        <p>
          <span>订单号</span>
          <span>{{ordersObj.orderSn}}</span>
        </p>
      </div>
    </div>

    <p class="bgcolor"></p>

    <van-steps direction="vertical" :active="ordersObj.state-1">
      <van-step>
        <h3>订单完成时间</h3>
        <p>{{ordersObj.finishTime}}</p>
      </van-step>
      <van-step>
        <h3>
          <span class="money" v-show="ordersObj.state != 1 ">¥{{ordersObj.income}}</span>已转为可提现金额
        </h3>
        <p v-show="ordersObj.state != 1 ">{{ordersObj.updateTime}}</p>

        <h3 v-show="ordersObj.state == 3 ">
          发生部分退款，您的收入变为
          <span class="money">¥{{ordersObj.income}}</span>
        </h3>
        <p v-show="ordersObj.state == 3 ">{{ordersObj.arrivalTime}}</p>
      </van-step>
    </van-steps>
  </div>
</template>

<script>
import { normalOrderDetails } from "@/api/picker/index";
export default {
  data() {
    return {
      show: false,
      headerMsg: {
        title: "正常订单收入详情",
        url: ""
      },
      page: 1,
      ordersObj: {}
    };
  },
  mounted() {
    this.normalOrderDetails();
    this.headerMsg.url = this.$store.getters.url
  },
  methods: {
    normalOrderDetails() {
      let obj = {
        token: this.$store.getters.token || this.GetQueryString("token"),
        orderId: this.$route.query.id  // 订单ID
      };
      normalOrderDetails(obj).then(res => {
        this.ordersObj = res.content;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.content {
  p {
    margin: 0;
  }
  .order_msg {
    width: 375px;
    height: 117px;
    // margin: 44px 0 0 0;
    background: rgba(255, 255, 255, 1);
    display: flex;
    div {
      width: fit-content;
      height: 100%;
      p {
        width: 100%;
        height: 34px;
        margin: 0;
        display: flex;
        align-items: center;
        span {
          display: block;
          color: #1d1d1d;
        }
        span:first-child {
          width: 65px;
          height: 21px;
          margin-right: 15px;
          margin-left: 15px;
          font-size: 15px;
          color: #1d1d1d;
          text-align: left;
        }
        span:last-child {
          font-size: 15px;
        }
      }
      p:first-child {
        margin-top: 10px;
        span:last-child {
          color: #ec130c;
          font-weight: bold;
        }
      }
    }
  }
  .bgcolor {
    width: 100%;
    height: 10px;
    background: #f5f5f5;
    margin: 0;
  }
  /deep/.van-step__title {
    margin-top: -14px;
    text-align: left;
    margin-left: 20px;
    h3 {
      color: #1d1d1d;
      font-size: 18px;
      font-weight: bold;
    }
    span {
      font-size: 13px;
    }
    p {
      color: #666;
      font-size: 14px;
    }
    .money {
      color: #ec130c;
      font-weight: bold;
      font-size: 18px;
    }
  }
}
</style>

